<template>
  <component
    :is="href ? 'BasicLink' : 'span'"
    class="user-item"
    :href="href ? href : null"
    :appearance="href ? 'dark' : null"
  >
    <span class="user-item__avatar">
      <BasicAvatar
        v-if="avatar"
        :image="avatar"
        :size="avatarSize"
        roundness="full"
      />
    </span>
    <BasicText>{{title}}</BasicText>
  </component>
</template>

<script>
  import BasicAvatar from "src/components/BasicAvatar/BasicAvatar.vue";
  import BasicLink from "src/components/BasicLink/BasicLink.vue";
  import BasicText from "src/components/text/BasicText/BasicText.vue";
  import { bem } from "src/utils/bem.js";

  export default {
    name: 'UserItem',
    components: { BasicLink, BasicText, BasicAvatar },
    props: {
      title: {
        type: String,
        required: true,
      },
      href: String,
      avatar: Object,
      avatarSize: String,
    },
    methods: {
      bem,
    },
  }
</script>